export const API = process.env.REACT_APP_API_URL;
export const SITE_URL = process.env.REACT_APP_SITE_URL;
